import React from 'react'
import { Grid, Image, Modal, Button, Accordion, Icon, Segment } from 'semantic-ui-react'
import momentDateAndTime from '../../../../../helpers/momentDateAndTime'
import ImageAvater from '../../../../drive/Components/ImageAvater';

class ViewIssueLog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: -1
        }
    }



    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    close = () => {
        this.props.viewIssueLogsClick(false);
        this.setState({ activeIndex: -1 })
    }

    render() {
        const { activeIndex } = this.state
        return (
            <Modal
                className="filterModal basicModal"
                open={this.props.openIssueLog}
                size='small'
                closeIcon
                onClose={this.close}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>Activity Logs</Modal.Header>
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Accordion className="issueLog" >
                                {this.props.selectedActivityData && this.props.selectedActivityData.onHoldComments && this.props.selectedActivityData.onHoldComments.length !== 0 ?
                                    <Segment className="pad_0">
                                        <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                                            <Icon name='dropdown' />
                                            On Hold Comments
                                    </Accordion.Title>

                                        <Accordion.Content className="acc_content" active={activeIndex === 0}>

                                            {this.props.selectedActivityData && this.props.selectedActivityData.onHoldComments && this.props.selectedActivityData.onHoldComments.length !== 0 && this.props.selectedActivityData.onHoldComments.map((item, i) => {
                                                return <ol className="chat" key={i}>
                                                    {item.activateComment ?
                                                        <li className="self">
                                                            <ImageAvater user={this.props.selectedActivityData.onHoldComments[0].accountUserId} />
                                                            <div className="msg">
                                                                <b>{this.props.selectedActivityData.onHoldComments[0].accountUserId.firstName} {this.props.selectedActivityData.onHoldComments[0].accountUserId.lastName}</b>
                                                                <p><div dangerouslySetInnerHTML={{ __html: item.activateComment }} /></p>
                                                                <time>{momentDateAndTime(item.actiavteOnHoldDate)}</time>
                                                            </div>
                                                        </li> : ""}
                                                    <li className="other ">
                                                        <ImageAvater user={this.props.selectedActivityData.onHoldComments[0].accountUserId} />
                                                        <div className="msg">
                                                            <b>{this.props.selectedActivityData.onHoldComments[0].accountUserId.firstName} {this.props.selectedActivityData.onHoldComments[0].accountUserId.lastName}</b>
                                                            <p><div dangerouslySetInnerHTML={{ __html: item.comment }} /></p>
                                                            <time>{momentDateAndTime(item.onHoldDate)}</time>
                                                        </div>
                                                    </li>
                                                </ol>

                                            })}



                                        </Accordion.Content>
                                    </Segment> : ""}
                                {this.props.selectedActivityData && this.props.selectedActivityData.issueLogComments && this.props.selectedActivityData.issueLogComments.length !== 0 ?
                                    <Segment className="pad_0">


                                        <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                                            <Icon name='dropdown' />
                                            Issue
                                     </Accordion.Title>
                                        <Accordion.Content active={activeIndex === 1}>


                                            {this.props.selectedActivityData && this.props.selectedActivityData.issueLogComments && this.props.selectedActivityData.issueLogComments.length !== 0 && this.props.selectedActivityData.issueLogComments.map((item, i) => {
                                                return <ol className="chat" key={i}>
                                                    {item.issueResolveDate ?
                                                        <li className="self">
                                                            <ImageAvater user={this.props.selectedActivityData.issueLogComments[0].accountUserId} />
                                                            <div className="msg">
                                                                <b>{this.props.selectedActivityData.issueLogComments[0].accountUserId.firstName} {this.props.selectedActivityData.issueLogComments[0].accountUserId.lastName}</b>
                                                                <p><div dangerouslySetInnerHTML={{ __html: item.resolveComment }} /> </p>
                                                                <time> {momentDateAndTime(item.issueResolveDate)}</time>
                                                            </div>
                                                        </li> : ""}
                                                    <li className="other ">
                                                        <ImageAvater user={this.props.selectedActivityData.issueLogComments[0].accountUserId} />
                                                        <div className="msg">
                                                            <b>{this.props.selectedActivityData.issueLogComments[0].accountUserId.firstName} {this.props.selectedActivityData.issueLogComments[0].accountUserId.lastName}</b>
                                                            <p><div dangerouslySetInnerHTML={{ __html: item.issue }} />  </p>
                                                            <time>{momentDateAndTime(item.issueDate)}</time>
                                                        </div>
                                                    </li>

                                                </ol>
                                            })}


                                        </Accordion.Content>
                                    </Segment>
                                    : " "}
                            </Accordion>


                        </Grid.Row>
                    </Grid>

                </Modal.Content>
                <Modal.Actions className="pull-right">
                    <Button content='Close' className="button-cancel" onClick={this.close} />
                </Modal.Actions>
            </Modal>

        )
    }
}



export default ViewIssueLog;